import { render, staticRenderFns } from "./Watchlist.vue?vue&type=template&id=c53e20a4&scoped=true"
import script from "./Watchlist.vue?vue&type=script&setup=true&lang=ts"
export * from "./Watchlist.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Watchlist.vue?vue&type=style&index=0&id=c53e20a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c53e20a4",
  null
  
)

export default component.exports